import { BatchesBasePage } from './BatchesPage';
import { useEffect } from 'react';

export const ReuseConcretePage = () => {
  useEffect(() => {
    return () => {
      document.title = 'MasterAtlas Admin';
    };
  }, []);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    const setTitle = () => {
      timeout = setTimeout(() => {
        document.title =
          document.title === 'MasterAtlas Admin'
            ? 'Comeback!'
            : 'MasterAtlas Admin';
        setTitle();
      }, 1000);
    };

    const onFocus = (e: FocusEvent) => {
      clearTimeout(timeout);
      document.title = 'MasterAtlas Admin';
    };

    const onBlur = (e: FocusEvent) => {
      setTitle();
    };

    window.addEventListener('blur', onBlur);
    window.addEventListener('focus', onFocus);

    return () => {
      window.removeEventListener('blur', onBlur);
      window.removeEventListener('focus', onFocus);
    };
  }, []);

  return <BatchesBasePage reuseConcrete />;
};
